var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserSquareinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 26 21",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.696 20.138H22.28c2.256 0 3.373-1.107 3.373-3.32V3.691c0-2.212-1.117-3.33-3.373-3.33H3.696C1.451.361.323 1.48.323 3.691v13.127c0 2.213 1.128 3.32 3.373 3.32zm.022-1.73c-1.074 0-1.665-.57-1.665-1.686V3.788c0-1.117.59-1.697 1.665-1.697h18.54c1.064 0 1.666.58 1.666 1.697v12.934c0 1.117-.602 1.686-1.665 1.686h-2.041c-.903-2.675-3.76-4.565-7.219-4.565-3.47 0-6.327 1.89-7.219 4.565H3.718zm9.281-6.36c2.052.022 3.674-1.729 3.674-4.027 0-2.16-1.622-3.943-3.674-3.943-2.052 0-3.685 1.783-3.674 3.943.01 2.298 1.622 4.006 3.674 4.028z",
    fill: "inherit"
  })));
}

export default SvgUserSquareinline;